var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('splash-hero'),(!_vm.isMobile() && _vm.isPersian(_vm.currentLocale))?_c('div',[_c('customers')],1):_vm._e(),_c('world-coverage'),_c('affordable'),_c('connect-everywhere'),_c('admin-dashboard'),_c('Unlimited'),_c('security'),_c('download-app'),_c('pay-as-you-go')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }